import { StudioError } from '#~/error/index.js';
import { CalibrationActionType, calibrate } from './calibrate.js';
import { recordCalibrationCancel } from './cancel-gate.js';
import type { Stop } from './types.js';
import { track } from '#~/analytics/index.js';
import { EVENT_CATEGORIES, EVENT_NAMES } from '#~/analytics/constants/index.js';

/**
 * Stop device calibration.
 *
 * @param deviceId - Device ID.
 */
export const stop: Stop = async (deviceId) => {
  // TD3 (ENG-4026): arm the cancel gate the moment the user initiates a cancel,
  // BEFORE the stop command round-trips. This is the PRIMARY cancel path (the
  // "Calibrating…" badge X). Without it, a bridge that reports RUNNING->OK
  // shortly after the stop produces a false calibration_completed(success) — the
  // exact false-positive TD3 exists to suppress (confirmed missing in ITG PostHog
  // before this fix). The watchdog's in-prompt cancels arm the same shared gate.
  // Per rule: reference-rules-in-comments (ai.knowledge/global).
  recordCalibrationCancel(deviceId);

  try {
    await calibrate(deviceId, CalibrationActionType.CALIBRATION_ACTION_STOP);
    track({
      name: EVENT_NAMES.CANCEL_CALIBRATION,
      category: EVENT_CATEGORIES.CALIBRATION,
      properties: {
        deviceId
      }
    });
  } catch (cause) {
    throw new StudioError('Unable to stop device calibration.', { cause });
  }
};
